import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { severityColors } from 'style/theme';

const chartData = [
  {
    id: 'low',
    label: 'LOW',
    value: 0,
    color: severityColors.low
  },
  {
    id: 'suggestion',
    label: 'SUGGESTION',
    value: 0,
    color: severityColors.suggestion
  },
  {
    id: 'medium',
    label: 'MEDIUM',
    value: 0,
    color: severityColors.medium
  },
  {
    id: 'high',
    label: 'HIGH',
    value: 0,
    color: severityColors.high
  }
];

const getOptions = (title, subtitle) => {
  return {
    chart: {
      type: 'donut',
      height: 350,
      toolbar: {
        show: true,
        offsetX: 0,
        offsetY: 0,
        tools: {
          download: true
        }
      }
    },
    title: {
      text: title,
      style: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#333'
      }
    },
    subtitle: {
      text: subtitle,
      align: 'left',
      offsetY: 20,
      style: {
        fontSize: '10px',
        color: '#000'
      }
    },
    legend: {
      position: 'bottom',
      fontSize: '10px',
      markers: {
        radius: 0
      }
    },
    dataLabels: {
      enabled: false
    },
    responsive: [
      {
        breakpoint: 1475,
        options: {
          title: {
            style: {
              fontSize: '14px'
            }
          }
        }
      },
      {
        breakpoint: 1300,
        options: {
          title: {
            style: {
              fontSize: '13px'
            }
          }
        }
      }
    ]
  };
};

export function PieChart({ title, subtitle, data }) {
  const [options, setOptions] = useState();
  const [series, setSeries] = useState();

  const updateValues = () => {
    return Object.entries(data).map(([key, value]) => {
      let type = chartData.find((item) => item.id === key.toLowerCase());
      if (type) type.value = value;
      return type;
    });
  };

  useEffect(() => {
    if (data) {
      const severity = updateValues();
      setSeries(severity.map((d) => d.value));
      setOptions({
        ...getOptions(title, subtitle),
        colors: severity.map((d) => d.color),
        labels: severity.map((d) => d.label)
      });
    }
  }, [data]);

  return (
    <div class="chart">
      {series && options && <ReactApexChart options={options} series={series} type="donut" height={300} />}
    </div>
  );
}
